import { getSiteUrl } from './api';

/** Black wordmark on light backgrounds (`crawlervision_logo.png`, ~3:1, 1200×398 deploy). */
export const CRAWLERVISION_LOGO_FILENAME = 'crawlervision_logo.png';
/** White wordmark on dark/teal surfaces (`crawlervision_white_logo.png`, ~3:1). */
export const CRAWLERVISION_LOGO_WHITE_FILENAME = 'crawlervision_white_logo.png';

/** Intrinsic aspect of deployed wordmark PNGs (width ÷ height). */
export const CRAWLERVISION_LOGO_ASPECT = {
  onLight: 1200 / 398,
  onDark: 1200 / 398,
};

/** Width/height attrs for a target CSS height (reduces layout shift). */
export function crawlervisionLogoDimensions(heightPx, variant = 'onLight') {
  const aspect = CRAWLERVISION_LOGO_ASPECT[variant] ?? CRAWLERVISION_LOGO_ASPECT.onLight;
  return {
    width: Math.round(heightPx * aspect),
    height: heightPx,
  };
}

/**
 * Small square CV mark + generated circle (see scripts/build-cv-mark-assets.py, source: crawlervision_cv.png)
 */
export const CRAWLERVISION_CV_SQUARE_PNG = 'crawlervision_cv.png';
export const CRAWLERVISION_CV_CIRCLE_PNG = 'crawlervision_cv_circle.png';
export const FAVICON_SVG_FILENAME = 'favicon.svg';

/**
 * @param {'square' | 'circle'} shape — square mark, or same on white disc (corners transparent)
 */
export function getCvIconPath(shape = 'square') {
  const base = (typeof process !== 'undefined' && process.env && process.env.PUBLIC_URL) ? String(process.env.PUBLIC_URL) : '';
  const f = shape === 'circle' ? CRAWLERVISION_CV_CIRCLE_PNG : CRAWLERVISION_CV_SQUARE_PNG;
  return `${base}/${f}`.replace(/\/+/g, '/');
}

export function getCvIconAbsoluteUrl(shape = 'square') {
  const f = shape === 'circle' ? CRAWLERVISION_CV_CIRCLE_PNG : CRAWLERVISION_CV_SQUARE_PNG;
  return `${getSiteUrl()}/${f}`;
}

export function getFaviconPath() {
  const base = (typeof process !== 'undefined' && process.env && process.env.PUBLIC_URL) ? String(process.env.PUBLIC_URL) : '';
  return `${base}/${FAVICON_SVG_FILENAME}`.replace(/\/+/g, '/');
}

/**
 * @param {'onLight' | 'onDark'} variant — onLight = default PNG; onDark = white mark for dark surfaces
 */
function logoFilenameForVariant(variant) {
  return variant === 'onDark' ? CRAWLERVISION_LOGO_WHITE_FILENAME : CRAWLERVISION_LOGO_FILENAME;
}

/** Public path for same-origin <img src> (CRA: `/crawlervision_*.png`) */
export function getCrawlerVisionLogoPath(variant = 'onLight') {
  const base = (typeof process !== 'undefined' && process.env && process.env.PUBLIC_URL) ? String(process.env.PUBLIC_URL) : '';
  const f = logoFilenameForVariant(variant);
  return `${base}/${f}`.replace(/\/+/g, '/');
}

/** Absolute URL for meta and external references (defaults to on-light; favicon/og stay on the standard mark) */
export function getCrawlerVisionLogoAbsoluteUrl(variant = 'onLight') {
  return `${getSiteUrl()}/${logoFilenameForVariant(variant)}`;
}
